import {Button, Typography} from '@mui/material';
import {differenceInMinutes} from 'date-fns';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Loading from '../../components/Loading/Loading';

import {useLeadContext} from './LeadFormContext';
import {newUTCDate} from '../../utils/newUTCDate';

export const LeadSetupAccount: React.FC = () => {
  const {lead, refetchLead} = useLeadContext();
  const [isChecking, setIsChecking] = useState(true);
  // const {createAccount, createAccountLoading, error} = useCreateAccountFromLead();
  // const [timeoutError, setTimeoutError] = useState(false);
  const [startTime] = useState(() => newUTCDate());
  const navigate = useNavigate();
  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (lead?.account?.id) {
      navigate(`/account/${lead.account.id}`);
    } else if (lead) {
      // if after 5 minutes, stop refetching
      if (differenceInMinutes(startTime, newUTCDate()) <= 5) {
        timeout = setTimeout(() => {
          refetchLead();
        }, 15000);
      }
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [lead]);

  if (isChecking && differenceInMinutes(startTime, newUTCDate()) > 5) {
    return (
      <div>
        <Typography variant="h5">Account is taking longer than expected</Typography>
        <Button variant="outlined" onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </div>
    );
  }

  if (isChecking) {
    return (
      <div>
        <Typography variant="h5">Waiting for account to be set up</Typography>
        <Typography variant="h5">This may take up to 5 minutes...</Typography>
        {/* <Typography>You can refresh the page.</Typography>
        <Button variant="outlined" onClick={() => window.location.reload()}>
          Reload page
        </Button> */}
      </div>
    );
  }

  return <Loading entityName="account" />;
  // <div>
  //   {error ? (
  //     <Panel title="Error">
  //       <Box>
  //         <Typography variant="h5">Unable to continue</Typography>
  //         <Typography variant="body1">Error: {error}</Typography>
  //       </Box>
  //       <Button onClick={() => refetchLead()}>Try again</Button>
  //     </Panel>
  //   ) : null}
  // </div>
  // );
};
